module.exports = __webpack_public_path__ + "media/src/images/abouts/brands/cocacola-8d8d8e196c651ec1fd7029940f052535.jpg";